import {makeStyles} from "@material-ui/styles";

export default makeStyles(theme => ({
    snackbarButtons: {
        margin: theme.spacing(1)
    }
}))